import { EnaioAccessType } from "./EnaioAccessType";

export class EnaioCheckPermissionAccessTypeResult {
    accessType: EnaioAccessType = EnaioAccessType.openExec;
    allow = false;
    clause: string;
    readableClause: string;
}
